export function getBillingPeriod(interval, intervalCount) {
  if (intervalCount === 1) {
    return `${interval}`;
  }

  if (intervalCount === 3 && interval === 'month') {
    return 'quarter';
  }

  if (intervalCount === 6 && interval === 'month') {
    return 'semiannual';
  }

  return 'month';
}
